// extracted by mini-css-extract-plugin
module.exports = {"inner":"LRrv","block":"LRd7","withPadding":"LRar5","defTitle":"LRar7","content":"LRbd","dark":"LRaj9","noBg":"LRar9"};